"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const navmenu_item_1 = require("./navmenu-item");
class Navmenu extends React.PureComponent {
    render() {
        const { options, active, onChange } = this.props;
        const menuItems = [];
        for (let i in options) {
            menuItems.push(React.createElement(navmenu_item_1.default, { href: options[i].href, key: i, itemKey: i, notificationCount: options[i].notificationCount, onClick: onChange, isActive: active === parseInt(i, 10) }, options[i].name));
        }
        return (React.createElement("ul", { className: 'vf-navmenu' }, menuItems));
    }
}
exports.default = Navmenu;
